import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { createRol, getRolByRealEstate } from 'redux/rolesSlice';
import ButtonClose from 'utils/buttons/ButtonClose';
import ButtonSuccessSubmit from 'utils/buttons/ButtonSuccessSubmit';
import Permisos from './components/Permisos';
import AlternativeModalButtonsContainer from 'sites/common/AlternativeModalButtonsContainer';

const CrearRol = ({ show, setShow, realEstate, listaRoles }) => {
  const dispatch = useDispatch();

  const tablaPermisos = useSelector(state => state.permisos.data);

  const [errors, setErrors] = useState({
    errorFound: false,
    alert: null
  });

  const handleSwitch = e => {
    setRol({
      ...rol,
      permisos: {
        ...rol.permisos,
        [e.target.id]: !rol.permisos[e.target.id]
      }
    });
  };

  const permissionId = {};

  tablaPermisos.forEach(grupo =>
    grupo.permissions.map(perm => (permissionId[perm.id] = false))
  );

  useEffect(() => {
    setRol({
      ...rol,
      permisos: permissionId
    });
  }, [tablaPermisos]);

  const [rol, setRol] = useState({
    nombre: '',
    permisos: permissionId
  });

  useEffect(() => {
    if (rol.nombre.length < 2) {
      setErrors({
        errorFound: true,
        alert: 'Ingrese un nombre con mínimo 2 letras.'
      });
    } else if (
      listaRoles &&
      listaRoles.some(element => element.name === rol.nombre)
    ) {
      setErrors({
        errorFound: true,
        alert: 'El nombre ingresado ya está en uso.'
      });
    } else {
      setErrors({
        errorFound: false,
        alert: null
      });
    }
  }, [rol.nombre]);

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      if (!errors.errorFound) {
        await dispatch(createRol(rol, realEstate.id));
        await dispatch(getRolByRealEstate(realEstate.id));

        setRol({
          id: '',
          inmobiliaria: '',
          nombre: '',
          permisos: {}
        });

        setShow(false);
      }
    } catch (e) {
      console.log(e);
      return e;
    }
  };

  const handleCancel = async e => {
    try {
      e.preventDefault();
      setRol({
        id: '',
        inmobiliaria: '',
        nombre: '',
        permisos: {}
      });

      setShow(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Crear nuevo rol</Modal.Title>
      </Modal.Header>

      <Form
        className="d-flex flex-column justify-content-start"
        onSubmit={handleSubmit}
      >
        <Modal.Body>
          <Row className="gap-3">
            <Form.Group as={Col} xs={12}>
              <Form.Label className="fs-0">Nombre</Form.Label>

              <Form.Control
                size="sm"
                className="py-0"
                type="text"
                value={rol.nombre}
                onChange={e => setRol({ ...rol, nombre: e.target.value })}
                style={{ width: 'fit-content' }}
                isInvalid={errors.errorFound}
              />

              <Form.Control.Feedback type="invalid">
                {errors.alert}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} xs={12}>
              <Form.Label className="fs-0">Seleccionar permisos</Form.Label>

              <Row className="g-3">
                {tablaPermisos.map(({ name, permissions }, index) => (
                  <Col key={index} xs={12} sm={6}>
                    <Permisos
                      rol={rol}
                      name={name}
                      permissions={permissions}
                      handleSwitch={handleSwitch}
                    />
                  </Col>
                ))}
              </Row>
            </Form.Group>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <AlternativeModalButtonsContainer>
            <ButtonClose
              text="Cancelar"
              funcion={handleCancel}
              variant="secondary"
            />

            <ButtonSuccessSubmit
              text="Crear rol"
              disabled={
                errors.errorFound ||
                Object.keys(rol.permisos).filter(p => rol.permisos[p]).length <
                  1
              }
            />
          </AlternativeModalButtonsContainer>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

CrearRol.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  realEstate: PropTypes.object,
  listaRoles: PropTypes.array.isRequired
};

export default CrearRol;
